
import React from 'react';
import moment from 'moment';

const OnboardingPopupGrid = (props) => {
    const {
        selectedCandidates,
        setSelectedCandidates,
        setHideBar,
        setShowPopup,
        OnboardingCandidate,
        checkedIds,
        setCount,
        setCheckedIds
    } = props;

    let convertDate = (date) => {
        return moment(date).format('YYYY-MM-DD');
    };


    const handleCheckboxChange = (e, candidateId) => {
        const isChecked = e.target.checked;

        // Update selectedCandidates
        const updatedSelectedCandidates = isChecked
            ? [...selectedCandidates, OnboardingCandidate.find(c => c.id === candidateId)]
            : selectedCandidates.filter(c => c.id !== candidateId);
        setSelectedCandidates(updatedSelectedCandidates);

        // Update checkedIds
        const updatedCheckedIds = isChecked
            ? [...checkedIds, candidateId]
            : checkedIds.filter(id => id !== candidateId);
        setCheckedIds(updatedCheckedIds);

        // Update count
        setCount(updatedCheckedIds.length);

        // Update hideBar
        setHideBar(updatedCheckedIds.length === 0);

        // Close popup if no candidates are selected
        if (updatedSelectedCandidates.length === 0) {
            setShowPopup(false);
        }
    };

    return (
        <div>
            <div className="modal fade show" id="exampleModal" tabIndex={-1} style={{ "display": "block", backgroundColor: 'rgba(0,0,0,0.6)' }} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="align-items-center justify-content-inbetween">
                                <div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center">
                                            <div>
                                                <p className="font-15 tt-bold mb-0 d-flex me-3">Selected Candidates</p>
                                            </div>
                                        </div>
                                        <div>
                                            <button type="button" className="btn-close" onClick={() => setShowPopup(false)} aria-label="Close" />
                                        </div>
                                    </div>
                                    <div className="table-responsive rounded-3 recruitment-grid mt-3" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                        <table className="table bg-white hive-grid table-borderless mb-0">
                                            <thead className="hive-table-head" style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
                                                <tr>
                                                    <th className="bold-text font-12" ></th>
                                                    <th className="bold-text font-12" >Candidate Name<span className="ps-2"></span></th>
                                                    <th className="bold-text font-12">Candidate ID<span className="ps-2"></span></th>
                                                    <th className="bold-text font-12">Job Position</th>
                                                    <th className="bold-text font-12">CTC</th>
                                                    <th className="bold-text font-12">Offer Status</th>
                                                    <th className="bold-text font-12">Onboarding Date</th>
                                                    <th className="bold-text font-12">Document Status</th>
                                                    <th className="bold-text font-12">Joining Date</th>
                                                    <th className="bold-text font-12">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedCandidates.map((candidate, index) => (
                                                    <tr key={index} className="hive-table-data regular-text align-middle">
                                                        <td className="align-items-center">
                                                            <input
                                                                className="form-check-input mt-0 recruitemt-input-checkbox"
                                                                type="checkbox"
                                                                id={candidate.id}
                                                                checked={checkedIds.includes(candidate.id)}
                                                                onChange={(e) => handleCheckboxChange(e, candidate.id)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <div className="ms-2">
                                                                    <a href="#" className="table-name-style semibold-text mb-0">{candidate.first_name + ' ' + candidate.last_name}</a>
                                                                </div>
                                                            </div>
                                                            
                                                        </td>
                                                        <td>{candidate.id}</td>
                                                        <td>{candidate.job_position}</td>
                                                        <td>{candidate.annual_ctc}</td>
                                                        <td>{candidate.offerletter_status}</td>
                                                        <td>{convertDate(candidate.on_boarding_date)}</td>
                                                        <td>{candidate.document_verification == null ? 'Pending' : candidate.document_verification}</td>
                                                        <td>{convertDate(candidate.joining_date)}</td>
                                                        <td>{candidate.status}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OnboardingPopupGrid;